import reportWebVitals from './reportWebVitals';
import React from 'react';
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { Provider } from 'react-redux';

import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';

import Store from './redux/store/store';
import App from './App';
import Loader from "./shade/Loaders/Loaders";

import "./index.scss";

const persistor = persistStore(Store);

//Form
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={Store}>
    <PersistGate persistor={persistor}>
      <React.Fragment>
        <React.Suspense fallback={<Loader/>}>
          <HashRouter>
            <App />
          </HashRouter>
        </React.Suspense>
      </React.Fragment>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
